export const REPORT_LAYOUT = Object.freeze({
  coverageRowsPerPage: 60,
  healthMetricsPerPage: 18,
  sourcesPerPage: 7,
  maxMetricsPerSummary: 6,
  maxRecommendations: 8
})
